import { OwcBanner } from "@one/react";
import { THEME } from "@digitallab/grid-common-components";

const CLUSTER_TEXT =
  "Propagation to Equipment Repository is not available for all subcomponents. The respective rows will be disabled. Contact the Equipment Responsible Person if you want to provide update to Equipment Repository.";

const NON_CLUSTER_TEXT =
  "Propagation to Equipment Repository is not available. You have selected at least 1 equipment that requires additional review. Contact the Equipment Responsible Person if you want to provide update to Equipment Repository.";
export const PropagationDisabledBanner = ({ cluster = false }) => {
  return (
    <>
      <OwcBanner
        type="info"
        style={{
          top: 0,
          marginBottom: THEME["one-spacer-12"],
          gridColumn: "span 4",
          boxShadow: `${THEME["one-color-background-warning-1"]} 0 0 0 2px`
        }}
      >
        {cluster ? CLUSTER_TEXT : NON_CLUSTER_TEXT}
      </OwcBanner>
    </>
  );
};
